<template>
  <div class="myOrderList" v-loading="loading">
    <el-form :model="searchForm" inline>
      <el-form-item>
        <el-input v-model.trim="searchForm.title" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model.trim="searchForm.orderNo" placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <template v-if="orderList.length">
      <div class="orderbox_info" v-for="item in orderList" :key="item.oid">
        <div class="orderbox_info_header">
          <div>
            <p :class="{'waitPay': item.status===1}">{{ orderStatueMaps[item.status] }}</p>
            <span>{{ item.createTime }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{ item.merchantName }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>订单号： <i>{{ item.orderNumber }}</i></span>
          </div>
          <div class="order_money">
            订单金额：<i>{{ item.amount | decimal }}</i> 元
          </div>
        </div>
        <el-row class="order_goods_whole">
          <el-col :span="20">
            <div class="order-goods" v-for='goodsItem in item.orderCommodityList' :key="goodsItem.id">
              <el-image :src="goodsItem.specificationImg || goodsItem.commodityImage" class="good-cover">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div class="good-info">
                <p  @click="$tools.showGoodInBlank(goodsItem.commodityId)" class="good-name">{{ goodsItem.commodityName }}</p>
                <p class="good-attr">{{ goodsItem.attributes }}</p>
                <p class="good-price">{{ goodsItem.buyprice }} × {{ goodsItem.num || 1 }}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="4" class="btn-box">
            <el-button size="mini" @click="gotoDetail(item)">订单详情</el-button>
            <template v-if="item.status === 1">
              <!--待支付-->
              <el-button size="mini" type="primary" @click="payOrderNow(item)">立即支付</el-button>
              <el-button size="mini" type="primary" plain @click="cancelOrder(item)">取消订单</el-button>
            </template>
            <template v-if="item.status === 2">
              <!--待发货-->
            </template>
            <template v-if="item.status === 3">
              <!--待收货-->
              <template v-if="item.orderType === 1">
                <el-button size="mini" type="default" @click="delayConfirm(item)" v-if="item.isDelayConfirm !== 'Y'">延时收货</el-button>
                <el-button size="mini" type="primary" @click="confirmReceipt(item)">确认收货</el-button>
              </template>
              <el-button size="mini" type="primary" @click="orderUse(item)" v-if="item.orderType === 2 || item.orderType === 3">立即使用</el-button>
            </template>
            <template v-if="item.status === 4 && item.evaluationFlag === 'N'">
              <!--已完成-->
              <el-button size="mini" type="primary" @click="orderEvaluation(item)">订单评价</el-button>
            </template>
            <template v-if="item.status === 5">
              <!--已关闭-->
              <el-button size="mini" type="primary" plain @click="removeOrder(item)">移除订单</el-button>
            </template>
          </el-col>
        </el-row>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="{ total, pageSize, currentPage: pageNum }" @callFather="handlePageChange"></Pagination>
    </template>
    <template v-else>
      <empty>暂无相关订单</empty>
    </template>

    <order-qrcode ref="qrcode"></order-qrcode>
  </div>
</template>

<script type="text/ecmascript-6">
import Pagination from '@/components/Pagination';
import Empty from '@/components/empty';
import OrderQrcode from '@/components/orderQrcode';
import {
  showorderList,
  removeOrderItem,
  fetchOrderCancel,
  fetchOrderConfirm,
  fetchDelayConfirm
} from '../../api/xunyou'
export default {
  name: 'myOrderList',
  props: {
    status: Number
  },
  components: {
    Pagination,
    Empty,
    OrderQrcode
  },
  data() {
    return {
      loading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      orderList: [],
      searchForm: {
        title: null,
        orderNo: null
      },
      orderStatueMaps: {
        1: '等待买家付款',
        2: '等待卖家发货',
        3: '等待买家确认收货',
        4: '交易成功',
        5: '交易关闭',
        6: '退款待审核',
        7: '待财务审核',
        8: '等待卖家配货',
        9: '待评价',
        10: '已退单'
      }
    }
  },
  computed: {
    userId () {
      return this.$store.getters.userId;
    }
  },
  mounted () {
    this.getOrderList();
  },
  methods: {
    // 距离收货时间3天才允许延迟收货
    canDelay (time) {
      const diffTime = 3 * 24 * 60 * 60 * 1000;
      const confirmDate = new Date(time).getTime();
      const nowTime = new Date().getTime();
      return confirmDate - nowTime < diffTime;
    },
    // 延长收货
    delayConfirm (item) {
      this.$confirm('每笔订单只能延时收货一次！', '延时收货', {}).then(() => {
        if (this.canDelay(item.latestConfirmTime)) {
          fetchDelayConfirm({oid: item.oid})
            .then(res => {
            console.log('延时收货：', res);
            if (res.code === 0) {
              this.getList();
              this.$message.success('已延迟收货时间！');
            } else {
              this.$message.error(res.msg);
            }
          }).catch(err => {
            this.$message.error('延时收货失败，请稍后再试！');
          })
        } else {
          this.$message.error('仅距离收货时间3天内的订单允许延迟收货！');
        }
      }).catch(() => {
        console.error('取消');
      });
    },
    // 立即使用
    orderUse (order) {
      this.$refs.qrcode.show(order);
    },
    // 订单详情
    gotoDetail(order) {
      this.$router.push(`/myOrderDetail?orderNumber=${order.orderNumber}`)
    },
    // 立即支付
    payOrderNow(order) {
      this.$store.commit('SAVE_PAY_ORDER', [order.orderNumber]);
      this.$router.push('/orderNow');
    },

    // 取消订单
    cancelOrder(order) {
      this.$confirm('确定取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        fetchOrderCancel({orderNumber: order.orderNumber}).then(res => {
          this.loading = false;
          if (res.code === 0) {
            this.getOrderList();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('查询红包失败，请稍后再试！')
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },

    // 订单评价
    orderEvaluation(item) {
      this.$router.push(`/orderAppraisal?orderNumber=${item.orderNumber}&bxmId=${item.bxmId}`);
    },
    //   移出订单
    removeOrder(order) {
      this.$confirm('确定移除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        removeOrderItem({oid: order.oid}).then(res => {
          this.loading = false;
          if (res.code === 0) {
            this.getOrderList();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('移除失败，请稍后再试！')
        });
      }).catch(() => {});
    },
    // 确认收货
    confirmReceipt(item) {
      this.$confirm('确定收到货物，并且货物完好？', '确认收货？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.loading = true;
        fetchOrderConfirm({orderNumber: item.orderNumber}).then(res => {
          console.log('确认收货：', res);
          this.loading = false;
          if (res.code === 0) {
            this.getOrderList();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false;
          this.$message.error('确认收货失败，请稍后再试！');
        })
      }).catch(() => {});
    },
    // 重置
    reset () {
      this.searchForm.title = null;
      this.searchForm.orderNo = null;
      this.search();
    },
    // 搜索
    search () {
      this.pageNum = 1;
      this.getOrderList();
    },
    // 翻页
    handlePageChange (val) {
      this.pageSize = val.pageSize;
      this.pageNum = val.currentPage;
      this.getOrderList();
    },
    // 订单查询
    getOrderList() {
      const params = {
        muid: this.userId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: this.status || '',
        title: this.searchForm.title,
        orderNumber: this.searchForm.orderNo
      };
      this.loading = true
      showorderList(params).then(res => {
          console.log('订单列表：', res);
          this.loading = false
          if (res.code === 0) {
            this.orderList = res.rows;
            this.total = res.total
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('查询订单失败，请稍后再试！')
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.waitPay {
  color: var(--main-theme-color);
}
.btn-box{
  text-align: right;
}
.orderbox_info {
  margin-bottom: 10px;
  border: 1px solid #efefef;

  .orderbox_info_header {
    padding: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #efefef;
    display: flex;
    justify-content: space-between;
    p {
      font-size: 16px;
      margin-bottom: 5px;
    }

    .order_money i {
      font-size: 20px;
      color: var(--main-theme-color);
    }
  }
}
.order_goods_whole{
  padding: 20px;
  /deep/ .el-button+.el-button{
    margin-left: 0;
    margin-top: 5px;
  }
  .order-goods{
    display:flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    .good-cover{
      width: 70px;
      height: 70px;
      margin-right: 10px;
      border-radius: 5px;
      border: 1px solid #F5F5F5;
    }
    .good-name{
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
        color: #f47009;
      }
    }
    .good-attr{
      color: var(--main-theme-color);
      font-size: 12px;
    }
    .good-price{
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/myOrderList.vue